export const watchFormFields = function( formTextInputs ) {
  
  if ( formTextInputs ) {

    formTextInputs.forEach( (elem) => {

      const parentWrap = elem.closest(".has-label-shift");
      const className = "has-shifted-label";
  
      // validation styles
      if (parentWrap.classList.contains("gfield_error")) {
        parentWrap.classList.add(className);
      } else {
        if ( document.activeElement.closest(".has-label-shift") === parentWrap || elem.value.trim() !== "") {
          parentWrap.classList.add(className);
        } else {
          parentWrap.classList.remove(className);
        }
      }
    });
    
  }

}